import React from 'react';
import TodoProgressPanel from '../../../components/TodoProgressPanel';
import WebSearchSourcesPanel from '../../../components/WebSearchSourcesPanel';
import WorkingFolderPanel from '../../../components/WorkingFolderPanel';

const EMBEDDED_CLASS =
    'absolute top-0 right-0 bottom-0 w-72 z-20 bg-white border-l border-gray-200 shadow-xl p-3 overflow-y-auto flex flex-col gap-3 animate-slide-in-right';
const FLOATING_CLASS =
    'hidden xl:flex flex-col w-72 flex-shrink-0 pt-14 pb-4 pr-4 self-start sticky top-0 gap-3 animate-slide-in-right';

export default function RightPanel({
    isOpen,
    isEmbedded,
    todosProgress,
    searchSources,
    workspaceFiles,
    sessionId,
}) {
    const hasContent = todosProgress || searchSources || workspaceFiles;
    if (!hasContent || !isOpen) return null;

    return (
        <div className={isEmbedded ? EMBEDDED_CLASS : FLOATING_CLASS}>
            <TodoProgressPanel todos={todosProgress} />
            <WorkingFolderPanel files={workspaceFiles} sessionId={sessionId} />
            <WebSearchSourcesPanel sources={searchSources} />
        </div>
    );
}
